var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFilled2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6954 6.6582H12.1301V4.17898C12.1303 1.87693 9.82587 0 7.00004 0C4.17421 0 1.86958 1.87705 1.86958 4.17928V6.6585H1.30432C0.565256 6.6585 0 7.11896 0 7.721L0.000145572 15.9375C0.000145572 16.5395 0.565402 17 1.30447 17H12.6957C13.4347 17 14 16.5395 14 15.9375L13.9999 7.7207C13.9999 7.15411 13.3912 6.6582 12.6955 6.6582H12.6954ZM7.65213 11.8645V13.4582C7.65213 13.7415 7.34773 13.9895 6.99996 13.9895C6.65219 13.9895 6.3478 13.7415 6.3478 13.4582V11.8645C5.91298 11.652 5.60874 11.2978 5.60874 10.8374C5.60874 10.1999 6.2609 9.66866 7.04349 9.66866C7.82609 9.66866 8.47825 10.1999 8.47825 10.8374C8.43472 11.2624 8.13033 11.652 7.65213 11.8645ZM3.82599 6.6582V4.17898C3.82599 2.76227 5.26074 1.59351 6.99989 1.59351C8.73904 1.59351 10.1738 2.76227 10.1738 4.17898V6.6582H3.82599Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled2);
export default __webpack_public_path__ + "static/media/lock-filled2.49db4a733cb4c945e959da0ee5c9d009.svg";
export { ForwardRef as ReactComponent };